<!--
  - Copyright (c) 2023. Henry Zilek
  -->

<template>
    <transition name="fade">
        <div v-show="this.$store.state.showDictionaryPopup"
             ref="test-popup"
             v-closable="{
    exclude: ['test-button', 'test-popup', 'smallDict', 'small_popup']
                    }"
             class="popup-box"
             data_ref="small_popup"
        >

            <div class="container">
                <div class="container-img">
                    <svg id="Vrstva_1" data-name="Vrstva 1" viewBox="0 0 83.27 50" xmlns="http://www.w3.org/2000/svg">
                        <rect id="MenuSquare" class="cls-3" height="35.36" transform="translate(-10.19 25.4) rotate(-45)" width="35.36" x="7.89"
                              y="7.32"></rect>
                        <path class="cls-4"
                              d="M23.09,16.3v1.24H28V16.3a1.24,1.24,0,0,1,2.48,0v1.24h1.86a1.87,1.87,0,0,1,1.86,1.86v1.86H16.89V19.4a1.86,1.86,0,0,1,1.86-1.86h1.86V16.3a1.24,1.24,0,0,1,2.48,0Zm-6.2,6.2H34.24V33a1.86,1.86,0,0,1-1.86,1.86H18.75A1.86,1.86,0,0,1,16.89,33ZM20,25a.62.62,0,0,0-.62.62v3.71a.62.62,0,0,0,.62.62H23.7a.62.62,0,0,0,.62-.62V25.6A.62.62,0,0,0,23.7,25Z"></path>
                    </svg>
                </div>
                <div class="dictionary-title">
                    {{ getDictionaryItem.title }}
                </div>
                <div class="dictionary-shor-text" data_ref="neco">
                    {{ getDictionaryItem.shortText }}
                </div>
                <div class="link">
                    <HZLink :to="{name: 'Dictionary'}" class="dictionary-link">Slovník pojmů</HZLink>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "DictionaryAbstract",
    computed: {

        getDictionaryItem() {
            let result = this.$store.state.dictionary.find(item => item.id === this.$store.state.dictionaryId)

            result = result ? result : {title: "", shortTitle: ""}
            return result
        }
    }
}
</script>

<style scoped>
.popup-box {
    position: fixed;
    right: 0px;
    top: 50px;
    background: #F0F8FF;
    border-bottom-left-radius: 4px;
    box-shadow: -14px 15px 8px -3px rgba(0, 0, 0, 0.6);
    padding: 20px;
    color: #555585;
    min-height: 100px;
    min-width: 300px;
    max-width: 300px;
    text-align: left;
}

.fade-enter-active, .fade-leave-active {
    /*transition: all .5s ease;*/
    transition: all 0.3s ease-out;
}

.fade-enter-from, .fade-leave-to {
    transform: translateX(300px);
    opacity: 0
}

.link {
    margin-top: 30px;
    align-items: start;
    justify-items: start;
    display: block;
    text-align: left;
}

.container-img {
    position: absolute;
    top: -20px;
    left: -20px;
    min-width: 65px;
}

.dictionary-title {
    color: var(--e-global-color-secondary);
    text-align: left;
}

.dictionary-shor-text {
    margin-top: 10px;
}

.dictionary-link {
    color: var(--e-global-color-secondary);
    text-decoration: underline;
}

.dictionary-link:hover {
    font-weight: bold;
}

</style>